import { type RefObject, useCallback } from 'react';

interface UseWidgetsScrollProps {
  containerRef: RefObject<HTMLDivElement>;
}
const WAIT_AFTER_MS = 1000;

const waitFor = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export function useWidgetsScroll(props: UseWidgetsScrollProps) {
  const { containerRef } = props;

  const scrollWidgets = useCallback(async () => {
    const container = containerRef.current;
    if (container) {
      container.scrollTo({ left: container.scrollWidth, behavior: 'smooth' });
      await waitFor(WAIT_AFTER_MS);
      container.scrollTo({ left: -container.scrollWidth, behavior: 'smooth' });
    }
  }, [containerRef]);

  return { scrollWidgets };
}
